<template>
  <th class="text-left font-Aeonik text-[12px] font-medium leading-[14px]">
    <slot />
  </th>
</template>
